import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, GiftIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productImage, totalBonuses, totalVolumes } from '../data/offer';
const highlights = [{
  icon: BookOpenIcon,
  label: `${totalVolumes} comprehensive volumes`
}, {
  icon: GiftIcon,
  label: `${totalBonuses} exclusive bonuses`
}, {
  icon: ZapIcon,
  label: 'Instant access'
}];
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="bg-stage-deep warm-glow field-grid relative isolate overflow-hidden" data-id="element-103" data-mp="saruar6c52ch">
      <div className="harvest-bar h-2 w-full" aria-hidden="true" data-id="element-104" data-mp="ncq13df73mna" />

      <div className="mx-auto max-w-5xl px-4 pb-14 pt-12 text-center lg:pb-20 lg:pt-16" data-id="element-105" data-mp="neazje4mrpqf">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-md border border-moss/60 bg-moss/20 px-4 py-2 text-xs font-extrabold uppercase tracking-[.14em] text-mossGlow" data-id="element-106" data-mp="3czfl7z4xc761">
          <ZapIcon className="h-4 w-4" aria-hidden="true" data-id="element-107" data-mp="39b4hj226fw3g" /> Geology Complete Teaching Resource Collection
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-5 max-w-4xl text-balance text-4xl font-extrabold leading-[1.05] text-white sm:text-5xl lg:text-6xl" data-id="element-108" data-mp="3e84mf9naissz">
          Master your year of Earth science and geological processes
          <br data-id="element-109" data-mp="2vjpxqt0g3qvc" />
          <span className="text-goldLight" data-id="element-110" data-mp="2vjg9payyntsa">in one afternoon.</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-9 max-w-3xl" data-id="element-111" data-mp="2hkgh5s8buuqu">
          <img src={productImage} alt="Geology Complete Teaching Resource Collection: nine volumes and five bonus resources covering minerals, plate tectonics, stratigraphy, paleontology, mapping, landscapes and applied geology" className="mx-auto w-full drop-shadow-[0_24px_44px_rgba(8,22,10,.55)]" data-id="element-112" data-mp="nbbe31x26h6v" />
        </motion.div>

        <div className="mt-9" data-id="element-113" data-mp="1b04at0li8t2j">
          <Button onClick={scrollToPricing} arrow className="w-full sm:w-auto" data-id="element-114" data-mp="1622hznya1fdv">
            Get your collection now
          </Button>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-2 text-xs font-bold text-onDark" data-id="element-115" data-mp="11151dfsx0teh">
          {highlights.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-md border border-lineDark bg-forest/70 px-3 py-2" data-id="element-116" data-mp="3lsp3hdsd4jef">
              <Icon className="h-3.5 w-3.5 text-mossGlow" aria-hidden="true" data-id="element-117" data-mp="3htg5txu7c1dl" />
              {label}
            </li>)}
        </ul>

        <p className="mt-6 text-xs font-semibold uppercase tracking-[.14em] text-mutedDark" data-id="element-118" data-mp="21a4sds29ic4e">
          Created by earth science specialists, for educators worldwide · Updated 2026
        </p>
      </div>
    </section>;
}